goog.provide("shadow.js.shim.module$ol$source$TileArcGISRest");
goog.provide("module$shadow_js_shim_module$ol$source$TileArcGISRest");
shadow.js.shim.module$ol$source$TileArcGISRest = shadow.js.nativeProvides["ol/source/TileArcGISRest"] = shadow$bridge("ol/source/TileArcGISRest");
module$shadow_js_shim_module$ol$source$TileArcGISRest.default = shadow.js.shim.module$ol$source$TileArcGISRest;
